import React, { useMemo } from "react";
import SqlResultTableBody from "../SqlResultDataTable/SqlResultTableBody";

/**
 * Chart source data as a data table — hidden on screen, included in PDF chart card capture only.
 */
export default function ChartPdfExportTable({ chart }) {
  const rawResults = useMemo(() => {
    const data = Array.isArray(chart?.data) ? chart.data : [];
    if (data.length === 0) return [];

    const xCol = chart.x_column || "xValue";
    const yCol = chart.y_column || "yValue";

    return data.map((d) => ({
      [xCol]: d.xValue ?? d[xCol] ?? d.x ?? d.category ?? "",
      [yCol]: d.yValue ?? d[yCol] ?? d.y ?? d.value ?? "",
    }));
  }, [chart]);

  if (rawResults.length === 0) return null;

  return (
    <div className="chart-pdf-export-only" aria-hidden="true">
      <div className="chat-data-wrapper chart-pdf-export-table-wrap">
        <SqlResultTableBody rawResults={rawResults} wrapperMode="message" />
      </div>
    </div>
  );
}
